export const CMS_HOMEPAGE_TOKEN = "homepage";
export const CMS_MAIN_MENU_TOKEN = "main-menu";
export const CMS_SIDEBAR_MENU_TOKEN = "sidebar-menu";

export const CMS_LOCALE_MAP = {
  vi: "vi_VN",
  en: "en_US",
  ja: "ja_JP",
} as const;
